import { useField } from 'react-final-form';

import PhoneField from 'ui/fields/PhoneField';
import { SUBSCRIPTION } from 'utils/formUtils';

const parser = v => v ?? {};

/** @type {React.FC<{ name: string, disabled: boolean, required: boolean, hideError: boolean, hideLabel: boolean, validateOnInit: boolean }>} */
const PhoneNumberDetailedInput = ({ name, validateOnInit, ...otherProps }) => {
  const { input: phoneNumberInput, meta } = useField(name, {
    parse: parser,
    format: parser,
    ...SUBSCRIPTION.ERROR,
  });

  // Handle validation message coming from phoneNumber.prefix || phoneNumber.local || phoneNumber
  const fieldError = meta.error?.prefix ?? meta.error?.local;
  const error = (validateOnInit || meta.touched) && fieldError;

  return <PhoneField {...otherProps} error={error} {...phoneNumberInput} />;
};
export default PhoneNumberDetailedInput;
